import { type Contract, ContractType } from '@/types/commercial/contracts';

export interface ProposalContractViewModel {
  id: string;
  type: ContractType;
  name: string;
  version: number;
  canView: boolean;
  canDownload: boolean;
  unavailableReason?: string;
}

export const PROPOSAL_CONTRACT_LABELS: Record<ContractType, string> = {
  [ContractType.SIM_CARD]: 'Contrato de SIM Card',
  [ContractType.LORA_ACTIVATION]: 'Contrato de Ativação LoRa',
  [ContractType.PLATFORM]: 'Contrato de Plataforma',
  [ContractType.TECHNICAL_SERVICES]: 'Contrato de Serviços Técnicos',
};

export function toProposalContractViewModel(contract: Contract): ProposalContractViewModel {
  return {
    id: contract.id,
    type: contract.type,
    name: PROPOSAL_CONTRACT_LABELS[contract.type],
    version: contract.version,
    canView: contract.type === ContractType.SIM_CARD,
    canDownload: contract.type === ContractType.SIM_CARD,
    unavailableReason:
      contract.type === ContractType.SIM_CARD
        ? undefined
        : 'PDF indisponível para este modelo de contrato.',
  };
}
